import React from 'react';
import {
    Select,
    Stack,
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const statusConditions = [
    { label: 'is ', value: 'EqualTo' },
    { label: 'is not', value: 'NotEqualTo' },
];

const statuses = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Draft', value: 'DRAFT' },
    { label: 'Archived', value: 'ARCHIVED' },
];

class ProductStatusFilterComponent extends React.Component {

    render() {

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={statusConditions}
                    value={this.props.filter.condition}
                    onChange={(selected) => this.onConditionChange(selected)}
                />
                <Select
                    options={statuses}
                    value={this.props.filter.status}
                    onChange={(selected) => this.onStatusChange(selected)}
                />
            </Stack>
        );
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.condition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onStatusChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.status = newValue;

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProductStatusFilterComponent;
